(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oi-collection-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oi-grid-density')) {
    class OiGridDensity extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick = (event) => {
        const button = event.target instanceof Element ? event.target.closest('[data-density]') : null;
        if (!(button instanceof HTMLButtonElement)) return;

        const value = button.dataset.density;
        if (value === 'compact') {
          document.documentElement.dataset.oiGridDensity = 'compact';
        } else {
          delete document.documentElement.dataset.oiGridDensity;
        }

        try {
          sessionStorage.setItem('oi-grid-density', value || 'default');
        } catch (error) {}

        this.sync();
      };

      sync() {
        const current = document.documentElement.dataset.oiGridDensity || 'default';
        for (const button of this.querySelectorAll('[data-density]')) {
          button.setAttribute('aria-pressed', String(button.getAttribute('data-density') === current));
        }
      }
    }

    customElements.define('oi-grid-density', OiGridDensity);
  }

  if (!window.oiSortListeners) {
    window.oiSortListeners = true;

    document.addEventListener('click', (event) => {
      for (const details of document.querySelectorAll('details[data-oi-sort][open]')) {
        if (event.target instanceof Node && !details.contains(event.target)) details.open = false;
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      for (const details of document.querySelectorAll('details[data-oi-sort][open]')) {
        details.open = false;
        details.querySelector('summary')?.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oi-product-story"] && !Shopify.designMode) return;
  try {
    
  // Abas da página de produto: o botão abre o `details` da mesma posição (o atributo `name` fecha o outro).
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-oi-tab]');
    if (!tab) return;
    const section = tab.closest('.oi-story');
    const items = section.querySelectorAll('.oi-story__item');
    const target = items[Number(tab.dataset.oiTab)];
    if (!target) return;
    target.open = true;
    section.querySelectorAll('[data-oi-tab]').forEach((other) => {
      other.setAttribute('aria-selected', String(other === tab));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
